exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#allTemplatesCheckbox input {\n  margin-left: 10px !important;\n}\n.ant-select-selection-selected-value {\n  overflow-x: hidden !important;\n}", ""]);

// exports
